import React from "react"
import { TextDescription } from "../components/text/Text"
import Footer from "../components/footer/Footer"
import { Page } from "../components/page/Page"
import styles from './Error.module.css'

const Error = () => {
    return (
        <div>
            <Footer bottom={'0px'} />
            <Page>
                <TextDescription bold>
                    {'OPS... algo deu errado!'}
                </TextDescription>
                <div style={{ height: '152px' }}>
                    <TextDescription >
                        {'Seu link está inválido. Favor não alterar a URL passada para você e tente novamente!'}
                    </TextDescription>
                </div>
                <div className={styles.image_container}>
                    <img src={'/sad.png'} className={styles.logo} alt="erro"/>
                </div>

            </Page>
        </div>
    )
}
export default Error